import { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../../assets/css/layout.css";
import "../../assets/css/login.css";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";

export default function Login() {
  const history = useHistory();

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      try {
        const respone = await apiRequest("login", "POST", { Phone, referral });
        setIsloading1(false);
        if (respone?.data?.status == 101) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: respone?.data?.msg || "Login failed",
          });
        } else if (respone?.data?.status == 200) {
          setOtp(true);
          setSecretCode(respone?.data?.secret);
          if (respone?.data?.myToken) {
            Swal.fire({
              icon: "success",
              title: "OTP",
              text: "Demo Account Testing OTP: " + respone?.data?.myToken,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: respone?.data?.msg || respone?.data?.error || "Login failed",
          });
        }
      } catch (error) {
        setIsloading1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error?.response?.data?.error ||
            error?.response?.data?.msg ||
            error?.message ||
            "Something went wrong",
        });
      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", {
        Phone,
        twofactor_code,
        referral,
        secretCode,
      });

      setIsloading1(false);

      if (response?.data?.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.msg,
        });
      } else if (response?.data?.status === 200) {
        const token = response?.data?.token;
        localStorage.setItem("token", token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.error ||
          error?.response?.data?.msg ||
          error?.message ||
          "Something went wrong!",
      });
    }
  };

  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true);
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false);
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="unique-login-container">
          <div className="side-accent"></div>

          <div className="main-auth-card">
            <div className="auth-inner">
              <header className="auth-intro">
                <div className="auth-logo-wrap">
                  <img src="/logo.png" className="auth-logo-img" alt="Logo" />
                </div>
                <h2>Sign in to Play</h2>
                <p>Enter your 10-digit mobile number to continue</p>
              </header>

              <div className="auth-fields-group">
                <div className="neo-input-box">
                  <input
                    name="mobile"
                    type="tel"
                    maxLength="10"
                    placeholder=" "
                    required
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <label>Mobile Number (+91)</label>
                </div>

                {otp && (
                  <div className="otp-wrapper-animate">
                    <div className="neo-input-box">
                      <input
                        name="password"
                        type="tel"
                        maxLength="6"
                        placeholder=" "
                        required
                        onChange={(e) => settwofactor_code(e.target.value)}
                      />
                      <label>Enter 6-Digit OTP</label>
                    </div>

                    <div className="otp-footer">
                      {isValid || seconds !== 0 ? (
                        <span className="timer-count">
                          Resend in <b>{seconds}s</b>
                        </span>
                      ) : (
                        showResend && (
                          <button
                            className="text-action-btn"
                            onClick={handleResendClick}
                          >
                            Resend Code
                          </button>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="auth-actions">
                {!otp ? (
                  <button
                    className={`glow-btn ${isLoading1 ? "active-loading" : ""}`}
                    onClick={(e) => {
                      handleClick(e);
                      setIsValid(true);
                    }}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <AppLoader size="sm" color="white" />
                    ) : (
                      "Get OTP"
                    )}
                  </button>
                ) : (
                  <button
                    className={`glow-btn verify-mode ${
                      isLoading1 ? "active-loading" : ""
                    }`}
                    onClick={(e) => varifyOtp(e)}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <AppLoader size="sm" color="white" />
                    ) : (
                      "Verify & Login"
                    )}
                  </button>
                )}
              </div>

              <div className="auth-trust-badge">
                <img src="/images/insurance.png" alt="Secure" />
                <span>100% Safe &amp; Secure Verification</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
